Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = {
  iconUserData: "data:image/svg+xml,%3csvg width='20' height='20' xmlns='http://www.w3.org/2000/svg'%3e%3cg fill='currentColor' fill-rule='nonzero'%3e%3cpath d='M10 2a4 4 0 110 8 4 4 0 010-8zm0-2a6 6 0 100 12 6 6 0 000-12z'/%3e%3cpath d='M10 12c4.91 0 8 3.08 8 5.95a.19.19 0 01-.11.05H2.13a.31.31 0 01-.13-.09C2.07 15 5.11 12 10 12zm0-2c-6 0-10 4-10 8a2.17 2.17 0 002.11 2h15.78A2.1 2.1 0 0020 18c0-4-4-8-10-8z'/%3e%3c/g%3e%3c/svg%3e",
  iconUserWidth: 20,
  iconUserHeight: 20
};